'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosToggle = function IoIosToggle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 25c2 0 3.8 1.7 3.8 3.8s-1.8 3.7-3.8 3.7-3.7-1.7-3.7-3.7 1.7-3.8 3.7-3.8z m20-3.7c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5h-20c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5h20z m-20 12.5c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.2-5 5 2.3 5 5 5z m20-18.8c-2 0-3.7-1.7-3.7-3.7s1.7-3.8 3.7-3.8 3.8 1.7 3.8 3.8-1.8 3.7-3.8 3.7z m-20 3.8c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5h20c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5h-20z m20-12.5c-2.7 0-5 2.2-5 5s2.3 5 5 5 5-2.3 5-5-2.3-5-5-5z' })
        )
    );
};

exports.default = IoIosToggle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-toggle.js
// module id = 2307
// module chunks = 0